import { RWA_URLS } from "~/consts";

// =============================================================================
// MCP CONFIG — edit these values to match your deployment.
// This is the single source of truth for the connection details shown to
// users in the final step of the wizard.
// =============================================================================

export const mcpConfig = {
    /** Display name of your MCP server (shown to the user + used in snippets). */
    serverName: "RWA.xyz",
    /** A short, unique key used inside config snippets (no spaces). */
    serverSlug: "rwa-xyz",
    /** The public URL of your MCP server endpoint. */
    serverUrl: "https://mcp.rwa.xyz",
    /** The OAuth authorization base URL (where Client ID/Secret are used). */
    authBaseUrl: "https://rwa.xyz/oauth",
    /** Link to the data catalog page. */
    dataCatalogUrl: "https://rwa.xyz/catalog",
    /** Link to the API documentation. */
    docsUrl: RWA_URLS.docsMcp,
    /** Link to the OAuth clients & tokens settings page. */
    oauthSettingsUrl: "https://rwa.xyz/tools/api/settings",
} as const;
